import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=f2cf4e3c&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=f2cf4e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf4e3c",
  null
  
)

export default component.exports